import React, { useState } from 'react';
import {
  Card,
  Title,
  Text,
  Tab,
  TabList,
  Grid,
  Metric,
  AreaChart,
  BarChart,
  DonutChart,
  Button,
  Select,
  SelectItem,
  List,
  ListItem
} from '@tremor/react';

export function AnalyticsDashboardPage() {
  const [dateRange, setDateRange] = useState('7d');

  // Placeholder data - would be fetched from API
  const summaryData = {
    totalReturns: 245,
    resaleRevenue: 52680,
    rentalRevenue: 12450,
    repairCost: 3200,
    aiSessions: 1890,
    customerGrowth: 156
  };

  const revenueData = [
    { date: '2024-03-14', resale: 4200, rental: 1200, total: 5400 },
    { date: '2024-03-15', resale: 3800, rental: 1100, total: 4900 },
    { date: '2024-03-16', resale: 4100, rental: 1300, total: 5400 },
    { date: '2024-03-17', resale: 4600, rental: 1400, total: 6000 },
    { date: '2024-03-18', resale: 4300, rental: 1250, total: 5550 },
    { date: '2024-03-19', resale: 4700, rental: 1500, total: 6200 },
    { date: '2024-03-20', resale: 4900, rental: 1600, total: 6500 }
  ];

  const itemOutcomesData = [
    { name: 'Resale', value: 45 },
    { name: 'Repair', value: 25 },
    { name: 'Refill', value: 20 },
    { name: 'Recycle', value: 10 }
  ];

  const aiUsageData = [
    { name: 'Web Chat', value: 60 },
    { name: 'In-Store Kiosk', value: 25 },
    { name: 'Mobile App', value: 15 }
  ];

  const recentActivity = [
    { message: 'Repair backlog increased by 10%', timestamp: '2 hours ago' },
    { message: 'AI policy update saved $2,400 in refunds', timestamp: '4 hours ago' },
    { message: 'New sustainability milestone reached', timestamp: '6 hours ago' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <Title>Analytics Dashboard</Title>
          <Text>High-level analytics from re-commerce, AI usage, finance, and customer engagement.</Text>
        </div>
        <Select value={dateRange} onValueChange={setDateRange}>
          <SelectItem value="7d">Last 7 Days</SelectItem>
          <SelectItem value="30d">Last 30 Days</SelectItem>
          <SelectItem value="90d">Last 90 Days</SelectItem>
          <SelectItem value="custom">Custom Range</SelectItem>
        </Select>
      </div>

      <Grid numItems={1} numItemsSm={2} numItemsLg={3} className="gap-6">
        <Card>
          <Text>Total Returns</Text>
          <Metric>{summaryData.totalReturns}</Metric>
        </Card>
        <Card>
          <Text>Resale Revenue</Text>
          <Metric>${summaryData.resaleRevenue.toLocaleString()}</Metric>
        </Card>
        <Card>
          <Text>Rental Revenue</Text>
          <Metric>${summaryData.rentalRevenue.toLocaleString()}</Metric>
        </Card>
        <Card>
          <Text>Repair Cost</Text>
          <Metric>${summaryData.repairCost.toLocaleString()}</Metric>
        </Card>
        <Card>
          <Text>AI Agent Sessions</Text>
          <Metric>{summaryData.aiSessions.toLocaleString()}</Metric>
        </Card>
        <Card>
          <Text>Customer Growth</Text>
          <Metric>+{summaryData.customerGrowth}</Metric>
        </Card>
      </Grid>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <Title>Re-commerce Revenue</Title>
          <AreaChart
            className="h-72 mt-4"
            data={revenueData}
            index="date"
            categories={["resale", "rental", "total"]}
            colors={["blue", "purple", "indigo"]}
          />
        </Card>

        <Card>
          <Title>Item Outcomes Distribution</Title>
          <BarChart
            className="h-72 mt-4"
            data={itemOutcomesData}
            index="name"
            categories={["value"]}
            colors={["blue"]}
          />
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <Title>AI Usage by Channel</Title>
          <DonutChart
            className="h-72 mt-4"
            data={aiUsageData}
            category="value"
            index="name"
            colors={["blue", "cyan", "indigo"]}
          />
        </Card>

        <Card>
          <Title>Recent Activity</Title>
          <List className="mt-4">
            {recentActivity.map((activity, index) => (
              <ListItem key={index}>
                <div>
                  <Text>{activity.message}</Text>
                  <Text className="text-tremor-content-subtle">{activity.timestamp}</Text>
                </div>
              </ListItem>
            ))}
          </List>
        </Card>
      </div>

      <div className="flex justify-end space-x-4">
        <Button variant="secondary">View Standard Reports</Button>
        <Button>Create Custom Report</Button>
      </div>
    </div>
  );
} 